/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteTemplateResource } from './';
import {
    QuoteTemplateResourceFromJSON,
    QuoteTemplateResourceFromJSONTyped,
    QuoteTemplateResourceToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteTemplateDetailsResource } from './';
import {
    TimeAndMaterialsQuoteTemplateDetailsResourceFromJSON,
    TimeAndMaterialsQuoteTemplateDetailsResourceFromJSONTyped,
    TimeAndMaterialsQuoteTemplateDetailsResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsQuoteTemplateResource
 */
export interface TimeAndMaterialsQuoteTemplateResource extends QuoteTemplateResource {
    /**
     * 
     * @type {TimeAndMaterialsQuoteTemplateDetailsResource}
     * @memberof TimeAndMaterialsQuoteTemplateResource
     */
    details: TimeAndMaterialsQuoteTemplateDetailsResource;
}

/**
 * Check if a given object implements the TimeAndMaterialsQuoteTemplateResource interface.
 */
export function instanceOfTimeAndMaterialsQuoteTemplateResource(value: object): value is TimeAndMaterialsQuoteTemplateResource {
    if (!('details' in value) || value['details'] === undefined) return false;
    return true;
}

export function TimeAndMaterialsQuoteTemplateResourceFromJSON(json: any): TimeAndMaterialsQuoteTemplateResource {
    return TimeAndMaterialsQuoteTemplateResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsQuoteTemplateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsQuoteTemplateResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteTemplateResourceFromJSONTyped(json, ignoreDiscriminator),
        'details': TimeAndMaterialsQuoteTemplateDetailsResourceFromJSON(json['details']),
    };
}

export function TimeAndMaterialsQuoteTemplateResourceToJSON(value?: TimeAndMaterialsQuoteTemplateResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...QuoteTemplateResourceToJSON(value, true),
        'details': TimeAndMaterialsQuoteTemplateDetailsResourceToJSON(value['details']),
    };
}

